import React from 'react';
import Button from './ui/Button';

const PageHeader = ({ 
  title, 
  subtitle, 
  actions = [],
  breadcrumbs = [],
  className = "" 
}) => {
  return (
    <div className={`bg-white border-b border-gray-200 px-6 py-4 ${className}`}>
      {breadcrumbs?.length > 0 && (
        <nav className="flex mb-4" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-2">
            {breadcrumbs?.map((crumb, index) => (
              <li key={index} className="flex items-center">
                {index > 0 && (
                  <svg className="h-4 w-4 text-gray-400 mx-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                )}
                {crumb?.href ? (
                  <a href={crumb?.href} className="text-sm text-gray-500 hover:text-gray-700">
                    {crumb?.label}
                  </a>
                ) : (
                  <span className="text-sm text-gray-900 font-medium">
                    {crumb?.label}
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-gray-600 mt-1">
              {subtitle}
            </p>
          )}
        </div>

        {actions?.length > 0 && (
          <div className="flex items-center space-x-3">
            {actions?.map((action, index) => (
              <Button
                key={index}
                variant={action?.variant || 'default'}
                onClick={action?.onClick}
                disabled={action?.disabled}
                className="inline-flex items-center"
              >
                {action?.icon && (
                  <action.icon className="h-4 w-4 mr-2" />
                )}
                {action?.label}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;